import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const TBI_BNPL: PaymentMethod = {
    id: PAYMENT_METHOD_ID.TbiBnpl,
    name: 'tbi',
    displayName: 'tbi bank'
};
